import axios from 'axios';

import type { IUserSuggestedEmailUpdate } from '@bb/users';
import type { AxiosRequestBuilder } from '@/app-package';

export interface IGetEmailSuggestionsForUserParams {
  userId: string;
}
export declare type IGetEmailSuggestionsForUserRequest = AxiosRequestBuilder<
  IGetEmailSuggestionsForUserParams,
  'get'
>;
export declare type IGetEmailSuggestionsForUserResponse =
  IUserSuggestedEmailUpdate[];

const getEmailSuggestionsForUser = async (
  params: IGetEmailSuggestionsForUserParams,
) => {
  const url = `/suggested_user_update/email_suggestions/${params.userId}`;

  const config: IGetEmailSuggestionsForUserRequest = { url, method: 'get' };

  const { data } =
    await axios.request<IGetEmailSuggestionsForUserResponse>(config);

  return data;
};

export default getEmailSuggestionsForUser;
